const clientBranches = company =>
  Array.isArray(company?.branches)
    ? company.branches
    : Array.isArray(company?.branches?.items)
    ? company.branches.items
    : [];

export const sortedClientBranches = company =>
  [...clientBranches(company)].sort((firstBranch, secondBranch) => {
    const firstName = firstBranch?.name?.trim() || '';
    const secondName = secondBranch?.name?.trim() || '';

    if (!firstName) return secondName ? 1 : 0;
    if (!secondName) return -1;

    return firstName.localeCompare(secondName, undefined, {
      numeric: true,
      sensitivity: 'base',
    });
  });

export const defaultClientBranch = (company, selectedBranch = null) => {
  if (selectedBranch?.id) {
    return selectedBranch;
  }

  const branches = clientBranches(company);
  const configuredBranch = branches.find(branch => branch?.id === company?.defaultClientLocationId);

  return configuredBranch || branches[0] || null;
};
